import { useEffect } from 'react';
import { useAuth } from '../../components/features/auth/AuthGuard';
import ObjectiveList from '../../components/features/performance/ObjectiveList';
import { PERMISSIONS } from '../../constants';
import { Box, Alert } from '@mui/material';

const ObjectivesPage = () => {
  const { hasPermission } = useAuth();

  // Check if user has permission to view objectives
  if (!hasPermission(PERMISSIONS.PERFORMANCE_READ)) {
    return (
      <Box p={3}>
        <Alert severity="error">
          You don't have permission to view performance objectives.
        </Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <ObjectiveList 
        type="all"
        title="All Performance Objectives"
      />
    </Box>
  );
};

export default ObjectivesPage;
